import './LandingPage.css';

import { HeroSection } from '../../components/heroSection/HeroSection';
import { VisionSection } from '../../components/visionSection/VisionSection';
import { AboutSection } from '../../components/aboutSection/AboutSection';
import { MissionSection } from '../../components/missionSection/MissionSection';
import { BetaProcessSection } from '../../components/betaProcessSection/BetaProcessSection';
import { ProtoytypeSection } from '../../components/prototypeSection/PrototypeSection';
import { TeamSection } from '../../components/teamSection/TeamSection';
import { BenefitSection } from '../../components/benefitSection/BenefitSection';
import { FaqSection } from '../../components/faqSection/FaqSection';
import { MobileFooter } from '../../components/mobileFooter/MobileFooter';
import { EndCta } from '../../components/endCta/EndCta';
import { BlogSection } from '../../components/blogSection/BlogSection';
import { useScrollTracking } from '../../hooks/scrollTracker';
import { useEffect } from 'react';
import Plausible from 'plausible-tracker';

const plausible = Plausible({ domain: 'erledix.de' });

function LandingPage() {
	useScrollTracking();
	useEffect(() => {
		const handleLoad = () => {
			plausible.trackEvent('siteFullyLoaded', { props: { siteFullyLoaded: true } });
		};

		if (document.readyState === 'complete') {
			handleLoad();
		} else {
			window.addEventListener('load', handleLoad);
		}

		return () => {
			window.removeEventListener('load', handleLoad);
		};
	}, []);
	return (
		<div className='App'>
			<HeroSection />
			<main>
				<VisionSection />
				<AboutSection />
				<BetaProcessSection />
				<MissionSection />
				{/* <IntroVideo poster={FamilyImg} videoSrc={'../../assets/intro.mp4'} /> */}
				{/* <ProtoytypeSection /> */}
				<TeamSection />
				<BenefitSection />
				<FaqSection />
				<BlogSection />
				<EndCta />
				<MobileFooter />
			</main>
		</div>
	);
}

export default LandingPage;
